
import { FC } from 'react';
import { useField } from "formik";
import { IBaseField } from './BaseField';
import { PassportIssue } from 'src/Controls';

interface IPassportIssueFieldProps extends IBaseField {
	/** Наименование поля с кодом подразделения */
	codeField: string;
	/** Наименование поля с наименованием подразделения */
	nameFiled: string;
	/** Все значения формы */
	values: any;
	/** Функция установки значения выбранного поля */
	setFieldValue: (field: string, value: string, shouldValidate?: boolean) => void;
};

/** Компонента - поле формы ввода кем выдан паспорт */
const PassportIssueField: FC<IPassportIssueFieldProps> = ( { name, values, nameFiled, codeField, setFieldValue, ...otherProps } ) => {

	const getFullName = ( propertiesName: string ) => name.concat('.').concat(propertiesName);
	const _nameField = getFullName(nameFiled);
	const _codeField = getFullName(codeField);

	const [ inputProps, meta, helpers ] = useField( _nameField );
	
	const setValueHandler = ( value: any ) => {
		if ( !value ) {
			setFieldValue( _codeField, '', true );
			setFieldValue( _nameField, '', true  );
		}
		else {
			setFieldValue( _codeField, value.code, true );
			setFieldValue( _nameField, value.name, true  );
		}
		setTimeout(() => {
			helpers.setTouched( true );
		}, 100 );
	};

	const packageValue = () => {
		if ( !!values && !!values[name] ) {
			const _code = values[name][codeField] ?? "";
			const _name = values[name][nameFiled] ?? "";
			if ( _code && _name )
				return { code: _code, name: _name };
		}
		return null;
	};

	const onBlur = () => helpers.setTouched( true, true );

	return (
		<PassportIssue
			{...inputProps}
			{...meta}
			{...otherProps}
			onBlur={onBlur}
			value={packageValue()}
			setValue={setValueHandler}
		/>
	);
};

export default PassportIssueField;
